// Sidebar akun UMKM (role 5): kasir POS. Juga dipakai sebagai grup POS di sidebar admin.
export default [
  {
    component: 'CNavTitle',
    name: 'Kasir',
  },
  {
    component: 'CNavItem',
    name: 'Kasir',
    to: '/pos/kasir',
    icon: 'cil-cart',
  },
  {
    component: 'CNavItem',
    name: 'Riwayat Penjualan',
    to: '/pos/riwayat',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Kasbon',
    to: '/pos/kasbon',
    icon: 'cil-wallet',
  },
  {
    component: 'CNavTitle',
    name: 'Toko',
  },
  {
    component: 'CNavItem',
    name: 'Barang & Stok',
    to: '/pos/barang',
    icon: 'cil-storage',
  },
  {
    component: 'CNavItem',
    name: 'Pengeluaran',
    to: '/pos/pengeluaran',
    icon: 'cil-money',
  },
  {
    component: 'CNavItem',
    name: 'Laporan',
    to: '/pos/laporan',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavItem',
    name: 'Info Toko',
    to: '/pos/toko',
    icon: 'cil-home',
  },
]
